import WebGalleryPhotoGroupCard from './WebGalleryPhotoGroupCard';

export default WebGalleryPhotoGroupCard;
